var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeteran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87524 4.43779L4.49994 5.08767L6.12466 4.43779V0H2.87524V4.43779Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49994 11.3729C5.39724 11.3729 6.12464 10.6455 6.12464 9.74824C6.12464 8.85094 5.39724 8.12354 4.49994 8.12354C3.60265 8.12354 2.87524 8.85094 2.87524 9.74824C2.87524 10.6455 3.60265 11.3729 4.49994 11.3729Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90988 0.4642C8.90912 0.208141 8.70174 0.00075956 8.44568 0H6.58887V4.25211L8.4712 3.5001C8.73694 3.39532 8.91112 3.13818 8.90988 2.85254V0.4642Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0900947 2.85252C0.088836 3.13816 0.263036 3.3953 0.528773 3.50008L2.41112 4.25208V0H0.554294C0.298236 0.00075956 0.0908542 0.208141 0.0900947 0.4642V2.85252Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54539 8.5204C1.47525 8.49994 1.39957 8.51369 1.34113 8.55753C1.28269 8.60137 1.24829 8.67016 1.24829 8.74321L1.25061 10.7532C1.2512 10.826 1.28573 10.8944 1.344 10.9381C1.40226 10.9819 1.47761 10.9958 1.54769 10.976L2.62231 10.6604C2.34069 10.0849 2.34069 9.41154 2.62231 8.83605L1.54539 8.5204Z",
    fill: "#787878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45233 10.9761C7.52242 10.996 7.59775 10.982 7.65602 10.9383C7.71429 10.8946 7.74884 10.8262 7.7494 10.7533L7.75172 8.74333C7.75172 8.67029 7.71732 8.60149 7.65888 8.55765C7.60044 8.51382 7.52477 8.50006 7.45463 8.52052L6.37769 8.83617C6.65931 9.41168 6.65931 10.085 6.37769 10.6605L7.45233 10.9761Z",
    fill: "#787878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27226 6.79586L3.58791 7.87048C4.16342 7.58885 4.83673 7.58885 5.41222 7.87048L5.72787 6.79586C5.74771 6.72576 5.73371 6.65043 5.69 6.59216C5.6463 6.5339 5.57789 6.49935 5.50506 6.49878L4.51399 6.49646C4.50934 6.49646 4.5047 6.49878 4.50005 6.49878C4.49541 6.49878 4.49077 6.49646 4.48612 6.49646L3.49505 6.49878C3.42219 6.49937 3.35381 6.5339 3.3101 6.59216C3.26642 6.65043 3.25242 6.72578 3.27226 6.79586Z",
    fill: "#787878"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50005 11.8372C4.18388 11.8372 3.87187 11.765 3.58788 11.626L3.27223 12.7029C3.25177 12.7731 3.26553 12.8487 3.30936 12.9072C3.3532 12.9656 3.42199 13 3.49504 13H5.50503C5.57808 13 5.64688 12.9656 5.69071 12.9072C5.73455 12.8487 5.74831 12.7731 5.72784 12.7029L5.41219 11.626C5.12823 11.765 4.81622 11.8372 4.50005 11.8372Z",
    fill: "#787878"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50009 6.26678C4.75646 6.26678 4.96429 6.05895 4.96429 5.80258C4.96429 5.54621 4.75646 5.33838 4.50009 5.33838C4.24372 5.33838 4.03589 5.54621 4.03589 5.80258C4.03589 6.05895 4.24372 6.26678 4.50009 6.26678Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteran);
export default __webpack_public_path__ + "static/media/Veteran.1c9ca4a32aac07c6856967b4eadf319c.svg";
export { ForwardRef as ReactComponent };